<template>
  <div class="table-wrapper" :class="fixedTable?'layout-fixed':''" style="minHeight: 300px;">
    <!--<slot name="headTable">-->
      <div class="table-head-wrapper" :style="{[fixed ? 'marginRight' : 'paddingRight']: isScroll?(isIE ? '17px' : '6px'):0}">
        <table cellspacing="0" cellpadding="0" border="0" class="table-head">
          <slot name="header"></slot>
        </table>
      </div>
    <!--</slot>-->
    <div class="table-body-wrapper" :style="{overflowY: isScroll?'scroll':'unset', height:isHeight?height+'px':'auto', minHeight: minHeight?height+'px':''}">
      <table cellspacing="0" cellpadding="0" border="0" :class="['table-body', isEmpty ? 'empty' : '']">
        <slot name="body"></slot>
      </table>
      <div style="width: 100%;height: 100%;" :style="{height: type==2? height + 'px' : '100%'}" class="relative" v-if="showNoData">
        <div v-if="type==1" class="absolute" style="top: 50%;left: 50%;transform: translate(-50%,-50%);">
          <img src="@/assets/images/default_empty.png"/>
          <div class="text-align-center font-16 color-999">
            {{noDataText}}
          </div>
        </div>
        <div v-if="type==2" class="text-align-center" style="top: 50%;left: 50%;position: fixed">
          <div class="text-align-center color-white" style="width:56px;height:56px;line-height:56px;background:rgba(33,37,48,0.15);border-radius: 50%;margin: 0 auto;">
            <i class="r2-icon-action_description" style="font-size: 30px;"></i>
          </div>
          <div class="text-align-center font-16 color-999" style="font-size:14px;margin-top: 12px">
            <slot name="no-data">
              {{noDataText}}
            </slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import {backendUrl} from '@/assets/js/config';
// import Bus from '@/assets/utils/bus';
import {isIE} from '@/assets/utils'
export default {
  name: 'SimpleTable',
  data () {
    return {
      uploadLayerShow: false,
      fileName: '',
      isIE: isIE()
    }
  },
  props: {
    isScroll: {
      type: Boolean,
      default: true
    },
    height: {
      type: Number,
      default: 300
    },
    minHeight: {
      type: Boolean,
      default: false
    },
    isHeight: {
      type: Boolean,
      default: true
    },
    fixed: {
      type: Boolean,
      default: false
    },
    fixedTable: {
      type: Boolean,
      default: false
    },
    isEmpty: {
      type: Boolean,
      default: false
    },
    showNoData: {
      type: Boolean,
      default: false
    },
    noDataText: {
      type: String,
      default: '暂无数据'
    },
    type: {
      type: Number,
      default: 2
    }
  },
  watch: {
    fileName: function (val) {
      // this.checkModelError(val);
      console.log('files====', val)
    }
  },
  methods: {},
  destroyed () {

  },
  mounted () {

  }
}
</script>

<style lang="less" scoped>
  @import '~@/components/common/Table/Index.less';
</style>

